import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchCheckbooksState } from '../reducers/search-checkbooks.reducer';
import * as selectors from '../selectors/search-checkbooks.selectors';

@Injectable({ providedIn: 'root' })
export class SearchCheckbooksFacadeService extends FacadeService {
  constructor(public override store: Store<SearchCheckbooksState>) {
    super(store);
  }

  // OBSERVABLES

  panelExpandedValue$ = this.storeSelect(selectors.getPanelExpansion);
  checkbooksTypes$ = this.storeSelect(selectors.getCheckbooksTypes);
  selectedTypeId$ = this.storeSelect(selectors.getSelectedTypeId);
  cardNumber$ = this.storeSelect(selectors.getCardNumber);
  givenDate$ = this.storeSelect(selectors.getGivenDate);
  givenDateFormat$ = this.storeSelect(selectors.getGivenDateFormat);
  checkbookCode$ = this.storeSelect(selectors.getCheckbookCode);
  invoiceNumber$ = this.storeSelect(selectors.getInvoiceNumber);
  givenStatus$ = this.storeSelect(selectors.getGivenStatus);
  loyaltyMemberId$ = this.storeSelect(selectors.getLoyaltyMemberId);
  showAssignBtn$ = this.storeSelect(selectors.getShowAssignBtn);
  showUnassignBtn$ = this.storeSelect(selectors.getShowUnassignBtn);

  // OBSERVABLE'S VALUES

  get panelExpandedValue() {
    return this.storeSnapshot(this.panelExpandedValue$);
  }

  get selectedTypeId() {
    return this.storeSnapshot(this.selectedTypeId$);
  }

  get cardNumber() {
    return this.storeSnapshot(this.cardNumber$);
  }

  get givenDateFormat() {
    return this.storeSnapshot(this.givenDateFormat$);
  }

  get checkbookCode() {
    return this.storeSnapshot(this.checkbookCode$);
  }

  get invoiceNumber() {
    return this.storeSnapshot(this.invoiceNumber$);
  }

  get givenStatus() {
    return this.storeSnapshot(this.givenStatus$);
  }

  get loyaltyMemberId() {
    return this.storeSnapshot(this.loyaltyMemberId$);
  }

  get showAssignBtn() {
    return this.storeSnapshot(this.showAssignBtn$);
  }

  get showUnassignBtn() {
    return this.storeSnapshot(this.showUnassignBtn$);
  }
}
